var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 601 607"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-group_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 131",
    transform: "translate(0 .193)",
    stroke: "#707070",
    fill: "url(#shape-group_svg__a)",
    d: "M0 0h596v373H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-group_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(-.27 .193)",
    fill: "url(#shape-group_svg__a)",
    d: "M0 0h1314v1193H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-group_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 132",
    transform: "translate(.26)",
    fill: "currentColor",
    stroke: "#707070",
    d: "M0 0h209v607H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-group_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(.26 .371)",
    fill: "currentColor",
    d: "M0 0h1168v1060H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-group_svg__a",
    x1: 0.5,
    x2: 0.496,
    y2: 0.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40545"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(0 233.807)",
    opacity: 0.8,
    clipPath: "url(#shape-group_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    transform: "translate(-24.73)",
    clipPath: "url(#shape-group_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M1058.069 98.266S1001.36 0 887.947 0H426.2S312.782 0 256.078 98.266L25.2 498.192s-56.709 98.214 0 196.429l230.874 399.926s56.7 98.214 170.121 98.214h461.752s113.413 0 170.121-98.214l230.875-399.927s56.709-98.214 0-196.429z",
    transform: "translate(-.916 -.306)",
    fill: "url(#shape-group_svg__a)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    transform: "translate(391.74)",
    clipPath: "url(#shape-group_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    transform: "translate(0 -80.371)",
    clipPath: "url(#shape-group_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M940.64 87.37S890.219 0 789.382 0H378.835S277.994 0 227.577 87.37L22.303 442.95s-50.421 87.324 0 174.648l205.274 355.58s50.417 87.322 151.258 87.322h410.547s100.837 0 151.258-87.324L1145.914 617.6s50.421-87.324 0-174.648z",
    fill: "currentColor"
  })))))));
}
export default SvgShapeGroup;